const initialState = {
  products: [],
  activeProduct: { images: [], others: {} },
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PRODUCTS":
      return {
        ...state,
        products: action.payload,
      };
    case "SET_ACTIVE_PRODUCT":
      return {
        ...state,
        activeProduct: { ...action.payload, basePrice: action.payload.price },
      };

    default:
      return state;
  }
};

export default productsReducer;
